import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51af8f3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chart = _resolveComponent("chart")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, { title: "数据统计" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: [16, 16] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              md: 24,
              lg: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_chart, {
                  title: "交易",
                  name: "transactionAmount"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              md: 24,
              lg: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_chart, {
                  title: "订单",
                  name: "transactionAmount"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}